export default function isPasswordValid (pwd) {
        const specialChars = /[!@#$%^&*()_+\-=\[\]{};:'",.<>\/?\\|]/;
        return (
            /[A-Z]/.test(pwd) &&
            /[a-z]/.test(pwd) &&
            /\d/.test(pwd) &&
            specialChars.test(pwd) &&
            pwd.length >= 8
        );
    };